import { VClosePopper } from 'floating-vue'

export default VClosePopper
